import React from 'react';
import RoleBasedLayout from './RoleBasedLayout';

const AnalistaLayout = () => {
  return <RoleBasedLayout roleName="Analista" colorClass="blue" />;
};

export default AnalistaLayout;
